import { render, staticRenderFns } from "./ViewMenu.vue?vue&type=template&id=313c9ac9&scoped=true&"
import script from "./ViewMenu.vue?vue&type=script&lang=ts&"
export * from "./ViewMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ViewMenu.vue?vue&type=style&index=0&id=313c9ac9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313c9ac9",
  null
  
)

export default component.exports